function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useState } from "react";
import styled from "styled-components";
import { FlexRow, useIsMobile } from "../..";
import { useTextEditorContext, getMobileToolbarPosition } from ".";
export const Toolbar = ({
  children,
  editorContainerRef,
  hideInlineStyles,
  ...props
}) => {
  const {
    textSelected,
    editorFocus
  } = useTextEditorContext();
  const [toolbarPosition, setToolbarPosition] = useState({});
  const isMobile = useIsMobile();

  if (textSelected && !window.getSelection().isCollapsed && isMobile) {
    const selectedTextPosition = getMobileToolbarPosition(editorContainerRef, hideInlineStyles);

    if (JSON.stringify(selectedTextPosition) !== JSON.stringify(toolbarPosition)) {
      setToolbarPosition(selectedTextPosition);
    }
  }

  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    position: toolbarPosition,
    showToolbar: textSelected && editorFocus
  }, props), children);
};
const Wrapper = styled(FlexRow)`
  position: absolute;
  left: 12px;
  bottom: 8px;
  z-index: 0;
  @media only screen and ${props => props.theme.media.small} {
    background: #ffffff;
    border-radius: 6px;
    bottom: initial;
    box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.24);
    flex-wrap: nowrap;
    padding: 4px;
    left: ${props => props.position?.left}px;
    top: ${props => props.position?.bottom}px;
    opacity: ${props => props.showToolbar ? 1 : 0};
    visibility: ${props => props.showToolbar ? "visible" : "hidden"};
    transition: visibility 0.2s ease, opacity 0.2s ease;
    z-index: 100;
  }
`;